// extracted by mini-css-extract-plugin
export default {"offlineNotice":"OfflineNotice_offlineNotice__Xlqqv"};